import Values from "values.js";

export const LIGHT_COLORS = {
  PRIMARY: "#F2962C",
  PRIMARY_FILL: "#FEF5EA",
  PRIMARY50: "#fef5ea",
  PRIMARY100: "#fdefdf",
  PRIMARY200: "#f9cb96",
  PRIMARY300: "#f5ab56",
  PRIMARY400: "#F2962C",
  PRIMARY500: "#c27823",
  PRIMARY600: "#915a1a",
  PRIMARY700: "#613c12",
  PRIMARY800: "#582D1D",

  SECONDARY: "#000000",
  SECONDARY_FILL: "#e6e6e6",
  SECONDARY50: "#e6e6e6",
  SECONDARY100: "#d9d9d9",
  SECONDARY200: "#808080",
  SECONDARY300: "#333333",
  SECONDARY400: "#000000",
  SECONDARY500: "#000000",
  SECONDARY600: "#000000",
  SECONDARY700: "#000000",
  SECONDARY800: "#000000",

  INFO: "#1890FF",
  INFO_ALT: "#3480eb",
  INFO_FILL: "#E8F4FF",
  INFO50: "#e8f4ff",
  INFO100: "#dceeff",
  INFO200: "#8cc8ff",
  INFO300: "#46a6ff",
  INFO400: "#1890FF",
  INFO500: "#1373cc",
  INFO600: "#0e5699",
  INFO700: "#0a3a66",
  INFO800: "#062440",

  SUCCESS: "#00A400",
  SUCCESS_FILL: "#E7F2E7",
  SUCCESS50: "#e6f6e6",
  SUCCESS100: "#d9f1d9",
  SUCCESS200: "#80d280",
  SUCCESS300: "#33b633",
  SUCCESS400: "#00A400",
  SUCCESS500: "#008300",
  SUCCESS600: "#006200",
  SUCCESS700: "#004200",
  SUCCESS800: "#002900",

  WARNING: "#F5CB52",
  WARNING_FILL: "#FEFAEE",
  WARNING50: "#fefaee",
  WARNING100: "#fef7e5",
  WARNING200: "#fae5a9",
  WARNING300: "#f7d575",
  WARNING400: "#F5CB52",
  WARNING500: "#c4a242",
  WARNING600: "#937a31",
  WARNING700: "#625121",
  WARNING800: "#3d3315",

  ERROR: "#EA2440",
  ERROR_FILL: "#FDE9EC",
  ERROR50: "#fde9ec",
  ERROR100: "#fcdee2",
  ERROR200: "#f592a0",
  ERROR300: "#ee5066",
  ERROR400: "#EA2440",
  ERROR500: "#bb1d33",
  ERROR600: "#8c1626",
  ERROR700: "#5e0e1a",
  ERROR800: "#3b0910",

  SURFACE: "#FFFFFF",
  SURFACE_SECONDARY: "#edf0f2",
  SURFACE_PAGE: "#F7F8FA",
  BACKGROUND: "#F0F2F5",
  BACKGROUND_SECONDARY: "#fafafa",

  WHITE: "#FFFFFF",
  BLACK: "#000000",

  BORDER: "#E1E1E1",
  BORDER50: "#F5F5F5", // lightest
  BORDER100: "#EDEDED",
  BORDER200: "#E1E1E1", // default border
  BORDER300: "#CFCFCF",
  BORDER400: "#BDBDBD",
  BORDER500: "#A8A8A8",
  BORDER600: "#949494",
  BORDER700: "#757575",
  BORDER800: "#5C5C5C", // darkest

  // BORDER: "#E1E1E1",
  BORDER_LIGHT: "#EAEAEC",
  BORDER_DARK: "#E4E6EB",
  BORDER_DARKER: "#ced0d4",
  BORDER_INPUT: "#D9D9D9",
  BORDER_BACKGROUND: "#C8C8C8",

  TEXT_TITLE: "#0F0F0F",
  TEXT_TITLE_LIGHT: "#212121",
  TEXT_TITLE_LIGHTER: "#424242",

  TEXT_BODY: "#3F3F3F", // This is the text color
  TEXT_SUBTITLE: "#656565",
  TEXT_SUBTITLE_LIGHT: "#616161",
  TEXT_SUBTITLE_LIGHT2: "#9E9E9E",
  TEXT_SUBTITLE_LIGHT3: "#BDBDBD",

  TEXT_DISABLED: "#B2B2B2",

  TEXT_PRIMARY: "#FFFFFF",
  TEXT_SECONDARY: "#FFFFFF",

  ICON: "#4A4A59",
  ICON_ALT: "#BDBDBD",

  NOTIFICATION_PRIMARY: "#FC565E",
  EMAIL_PRIMARY: "#1A77F2",
  WHATSAPP_PRIMARY: "#32B743",

  BOX_SHADOW: "rgba(0, 0, 0, 0.1)",
  SCROLL_BAR: "rgba(0, 0, 0, 0.5)",

  TM_PRIMARY: "#F2962C",
  TM_PRIMARY_LIGHT: "#FFFBF1",
  TM_PRIMARY_DARK: "#582D1D",

  // chat bubble colors like whatsapp
  CHAT_BUBBLE_PRIMARY: "#DCF8C6",
  CHAT_BUBBLE_SECONDARY: "#FFFFFF",
  CHAT_BACKGROUND: "#ECE5DD",
  // WHATSAPP_MESSAGE_BG: '#d9fdd3',

  COUNT_DOWN: "#E5484D",

  BUTTON_HOVER_BRIGHTNESS: "90%",
};

export const DARK_COLORS = {
  PRIMARY: "#F2962C",
  PRIMARY_FILL: "#0c0802",
  PRIMARY50: "#0c0802",
  PRIMARY100: "#180f04",
  PRIMARY200: "#794b16",
  PRIMARY300: "#c27823",
  PRIMARY400: "#F2962C",
  PRIMARY500: "#f5ab56",
  PRIMARY600: "#f7c080",
  PRIMARY700: "#fad5ab",
  PRIMARY800: "#fcead5",

  SECONDARY: "#ffffff",
  SECONDARY_FILL: "#ffffff",
  SECONDARY50: "#ffffff",
  SECONDARY100: "#ffffff",
  SECONDARY200: "#ffffff",
  SECONDARY300: "#ffffff",
  SECONDARY400: "#ffffff",
  SECONDARY500: "#cccccc",
  SECONDARY600: "#999999",
  SECONDARY700: "#666666",
  SECONDARY800: "#404040",

  INFO: "#1890FF",
  INFO_ALT: "#3480eb",
  INFO_FILL: "#051d33",
  INFO50: "#01070d",
  INFO100: "#020e19",
  INFO200: "#0c4880",
  INFO300: "#1373cc",
  INFO400: "#1890FF",
  INFO500: "#46a6ff",
  INFO600: "#74bcff",
  INFO700: "#a3d3ff",
  INFO800: "#d1e9ff",

  SUCCESS: "#00A400",
  SUCCESS_FILL: "#031903",
  SUCCESS50: "#000800",
  SUCCESS100: "#001000",
  SUCCESS200: "#005200",
  SUCCESS300: "#008300",
  SUCCESS400: "#00A400",
  SUCCESS500: "#33b633",
  SUCCESS600: "#66c866",
  SUCCESS700: "#99db99",
  SUCCESS800: "#ccedcc",

  WARNING: "#F5CB52",
  WARNING_FILL: "#312910",
  WARNING50: "#0c0a04",
  WARNING100: "#181408",
  WARNING200: "#7b6629",
  WARNING300: "#c4a242",
  WARNING400: "#F5CB52",
  WARNING500: "#f7d575",
  WARNING600: "#f9e097",
  WARNING700: "#fbeaba",
  WARNING800: "#fdf5dc",

  ERROR: "#EA2440",
  ERROR_FILL: "#2f070d",
  ERROR50: "#0c0203",
  ERROR100: "#170406",
  ERROR200: "#751220",
  ERROR300: "#bb1d33",
  ERROR400: "#EA2440",
  ERROR500: "#ee5066",
  ERROR600: "#f27c8c",
  ERROR700: "#f7a7b3",
  ERROR800: "#fbd3d9",

  SURFACE: "#262523",
  SURFACE_SECONDARY: "#4A4948",
  SURFACE_PAGE: "#080707",
  BACKGROUND: "#141311",
  BACKGROUND_SECONDARY: "#1E1E1E",

  WHITE: "#FFFFFF",
  BLACK: "#000000",

  BORDER: "#4F4F4F",
  BORDER50: "#2C2C2C", // lightest border shade on dark
  BORDER100: "#3D3D3D",
  BORDER200: "#4F4F4F", // default border shade on dark
  BORDER300: "#626262",
  BORDER400: "#757575",
  BORDER500: "#8A8A8A",
  BORDER600: "#9F9F9F",
  BORDER700: "#B4B4B4",
  BORDER800: "#D0D0D0", // almost light on dark

  // BORDER: "#FFFFFF4D",
  BORDER_LIGHT: "#FFFFFF1F",
  BORDER_DARK: "#FFFFFF33",
  BORDER_DARKER: "#FFFFFF66",
  BORDER_INPUT: "#FFFFFF99",
  BORDER_BACKGROUND: "#FFFFFF1F",

  TEXT_TITLE: "#FFFFFF",
  TEXT_TITLE_LIGHT: "#FFFFFFDE",
  TEXT_TITLE_LIGHTER: "#FFFFFF99",

  TEXT_BODY: "#FFFFFFDE",
  TEXT_SUBTITLE: "#FFFFFF99",
  TEXT_SUBTITLE_LIGHT: "#FFFFFF61",
  TEXT_SUBTITLE_LIGHT2: "#FFFFFF33",
  TEXT_SUBTITLE_LIGHT3: "#FFFFFF1A",

  TEXT_DISABLED: "#FFFFFF61",

  TEXT_PRIMARY: "#FFFFFF",
  TEXT_SECONDARY: "#FFFFFF",

  ICON: "#BDBDBD",
  ICON_ALT: "#4A4A59",

  NOTIFICATION_PRIMARY: "#FC565E",
  EMAIL_PRIMARY: "#1A77F2",
  WHATSAPP_PRIMARY: "#32B743",

  BOX_SHADOW: "rgba(255, 255, 255, 0.1)",
  SCROLL_BAR: "rgba(255, 255, 255, 0.5)",

  TM_PRIMARY: "#F2962C",
  TM_PRIMARY_LIGHT: "#FFFBF1",
  TM_PRIMARY_DARK: "#fcead5",

  // chat bubble dark colors like whatsapp
  CHAT_BUBBLE_PRIMARY: "#1E1E1E",
  CHAT_BUBBLE_SECONDARY: "#2F2F2F",
  CHAT_BACKGROUND: "#2D2D2D",
  // WHATSAPP_MESSAGE_BG: '#d9fdd3',

  COUNT_DOWN: "#E5484D",

  BUTTON_HOVER_BRIGHTNESS: "120%",
};

export const TM_PRIMARY = "#F2962C";
export const TM_PRIMARY_LIGHT = "#FFFBF1";
export const TM_SECONDARY = "#000000";
export const TM_INFO = "#1890FF";
export const TM_SUCCESS = "#00A400";
export const TM_WARNING = "#F5CB52";
export const TM_ERROR = "#EA2440";

/**
 * @param {string} color - Hex value format: #ffffff
 * @param {number} weight - Darken value between 0 and 100
 * @returns {string} - Hex value
 */
export const shadeColor = (color, weight) => {
  return `#${new Values(color).shade(weight).hex}`;
};

/**
 * @param {string} color - Hex value format: #ffffff
 * @param {number} weight - Lighten value between 0 and 100
 * @returns {string} - Hex value
 */
export const tintColor = (color, weight) => {
  return `#${new Values(color).tint(weight).hex}`;
};

const createColorShades = (color, colorBaseName) => ({
  [colorBaseName]: color,
  [`${colorBaseName}_FILL`]: tintColor(color, 90),
  [`${colorBaseName}50`]: tintColor(color, 90),
  [`${colorBaseName}100`]: tintColor(color, 85),
  [`${colorBaseName}200`]: tintColor(color, 50),
  [`${colorBaseName}300`]: tintColor(color, 20),
  [`${colorBaseName}400`]: color,
  [`${colorBaseName}500`]: shadeColor(color, 20),
  [`${colorBaseName}600`]: shadeColor(color, 40),
  [`${colorBaseName}700`]: shadeColor(color, 60),
  [`${colorBaseName}800`]: shadeColor(color, 75),
});

const createDarkColorShades = (color, colorBaseName) => ({
  [colorBaseName]: color,
  [`${colorBaseName}_FILL`]: shadeColor(color, 95),
  [`${colorBaseName}50`]: shadeColor(color, 95),
  [`${colorBaseName}100`]: shadeColor(color, 90),
  [`${colorBaseName}200`]: shadeColor(color, 50),
  [`${colorBaseName}300`]: shadeColor(color, 20),
  [`${colorBaseName}400`]: color,
  [`${colorBaseName}500`]: tintColor(color, 20),
  [`${colorBaseName}600`]: tintColor(color, 40),
  [`${colorBaseName}700`]: tintColor(color, 60),
  [`${colorBaseName}800`]: tintColor(color, 80),
});

export const generateColors = (colors) => {
  const { primary, secondary, info, success, warning, error } = colors;

  return {
    ...createColorShades(primary, "PRIMARY"),
    ...createColorShades(secondary, "SECONDARY"),
    ...createColorShades(info, "INFO"),
    ...createColorShades(success, "SUCCESS"),
    ...createColorShades(warning, "WARNING"),
    ...createColorShades(error, "ERROR"),
  };
};

export const generateDarkColors = (colors) => {
  const { primary, secondary, info, success, warning, error } = colors;

  return {
    ...createDarkColorShades(primary, "PRIMARY"),
    ...createDarkColorShades(secondary, "SECONDARY"),
    ...createDarkColorShades(info, "INFO"),
    ...createDarkColorShades(success, "SUCCESS"),
    ...createDarkColorShades(warning, "WARNING"),
    ...createDarkColorShades(error, "ERROR"),
  };
};
